//个人中心路由
const etlrouter = [
  {
    path: '/etlhome',
    name: 'etlhome',
    component: () => import('@/views/etl/index'),
    meta: {
      keepAlive: false,
      title:'化学纤维产业数仓'
    },
    // children: [{
    //   path: 'personal',
    //   name: 'personal',
    //   component: () => import('@/views/user/module/personal-center')
    // },{
    //   path: 'certificate',
    //   name: 'certificate',
    //   component: () => import('@/views/user/module/personal-certificate')
    // }]
  }
]

export default etlrouter



// WEBPACK FOOTER //
// ./src/router/etl.js